const auth = {
  namespaced: true,
  state: {
    axiosPromiseCancel: [] //接口请求存放数组
  },
  mutations: {
    /**
     * 请求依次存放数组中
     * @param state
     * @param data
     */
    setAxiosPromiseCancel(state, data) {
      state.axiosPromiseCancel.push(data);
    },
    /**
     * 取消数组中的所有请求,并重置数组
     * @param state
     */
    clearAxiosPromiseCancel(state) {
      // 路由跳转, 取消上个路由页面所有请求(如果还在pending状态的会直接变成canceled状态)
      if (state && state.axiosPromiseCancel.length > 0) {
        state.axiosPromiseCancel.forEach(e => {
          e && e.f();
        });
        state.axiosPromiseCancel = [];
      }
    },
    /**
     * 取消当前数组中重复请求
     * @param state
     * @param index
     */
    clearCommonAxiosPromiseCancel(state, index) {
      state.axiosPromiseCancel[index].f(); //重复请求执行取消操作
      state.axiosPromiseCancel.splice(index, 1); //把这条记录从数组中移除
    }
  }
};

export default auth;
